import axios from 'axios';
import { apiUrl } from '../../../../util/env';

export const yemboAxiosInstance = axios.create({
  baseURL: `${apiUrl}/`,
  timeout: 60000,
  data: {},
});
